import React, { Component } from 'react';
import { connect } from 'react-redux';
import { GECKO_CONSTS, GeckoModal, GeckoModalService } from 'ui';
import { renderError } from 'services/gecko-error';
import ImportReviewService from '../Service';
import DeltaChangesWrapper from '../DeltaChangesWrapper';
import CONSTS from 'constants/index.js';
import './styles.scss';

const pluraliseIfMoreThanOne = (word, count) => {
  if (count === 1) {
    return word;
  }
  return `${word}s`;
};

const defaultBlankDelta = {
  [CONSTS.DELTA_SAMPLE_ADD]: [],
  [CONSTS.DELTA_SAMPLE_REMOVE]: [],
  [CONSTS.DELTA_ANSWER_ADD]: [],
  [CONSTS.DELTA_ANSWER_REMOVE]: [],
  [CONSTS.DELTA_TAG_ADD]: [],
  [CONSTS.DELTA_TAG_REMOVE]: [],
  [CONSTS.DELTA_SKILL_ADD]: null,
  [CONSTS.DELTA_SKILL_REMOVE]: null,
};

export class DeltaModal extends Component {
  btns = [
    {
      name: 'Reject',
      icon: 'far fa-times',
      type: GECKO_CONSTS.BTN_TYPE_DEFAULT,
      handler: () => {
        return ImportReviewService.reject(
          this.props.botId,
          this.props.importId,
          this.props.delta
        )
          .then(() => {
            // Close modal
            new GeckoModalService().close();
          })
          .catch(renderError);
      },
    },
    {
      name: 'Approve',
      icon: 'far fa-check',
      type: GECKO_CONSTS.BTN_TYPE_PRIMARY,
      handler: () => {
        return ImportReviewService.approve(
          this.props.botId,
          this.props.importId,
          this.props.delta
        )
          .then(() => {
            // Close modal
            new GeckoModalService().close();
          })
          .catch(renderError);
      },
    },
  ];

  getQuestionsSummary() {
    const diffs = this.props.delta.diffs;
    if (
      diffs[CONSTS.DELTA_SAMPLE_ADD].length &&
      diffs[CONSTS.DELTA_SAMPLE_REMOVE].length
    ) {
      return `Add ${
        diffs[CONSTS.DELTA_SAMPLE_ADD].length
      } new ${pluraliseIfMoreThanOne(
        'sample',
        diffs[CONSTS.DELTA_SAMPLE_ADD].length
      )} and remove ${diffs[CONSTS.DELTA_SAMPLE_REMOVE].length}.`;
    }
    if (diffs[CONSTS.DELTA_SAMPLE_ADD].length) {
      return `Add ${
        diffs[CONSTS.DELTA_SAMPLE_ADD].length
      } new ${pluraliseIfMoreThanOne(
        'sample',
        diffs[CONSTS.DELTA_SAMPLE_ADD].length
      )}.`;
    }
    return `Remove ${
      diffs[CONSTS.DELTA_SAMPLE_REMOVE].length
    } ${pluraliseIfMoreThanOne(
      'sample',
      diffs[CONSTS.DELTA_SAMPLE_REMOVE].length
    )}.`;
  }

  getAnswersSummary() {
    const diffs = this.props.delta.diffs;
    if (
      diffs[CONSTS.DELTA_ANSWER_ADD].length &&
      diffs[CONSTS.DELTA_ANSWER_REMOVE].length
    ) {
      return `Add ${
        diffs[CONSTS.DELTA_ANSWER_ADD].length
      } new ${pluraliseIfMoreThanOne(
        'answer',
        diffs[CONSTS.DELTA_ANSWER_ADD].length
      )} and remove ${diffs[CONSTS.DELTA_ANSWER_REMOVE].length}.`;
    }
    if (diffs[CONSTS.DELTA_ANSWER_ADD].length) {
      return `Add ${
        diffs[CONSTS.DELTA_ANSWER_ADD].length
      } new ${pluraliseIfMoreThanOne(
        'answer',
        diffs[CONSTS.DELTA_ANSWER_ADD].length
      )}.`;
    }
    return `Remove ${
      diffs[CONSTS.DELTA_ANSWER_REMOVE].length
    } ${pluraliseIfMoreThanOne(
      'answer',
      diffs[CONSTS.DELTA_ANSWER_REMOVE].length
    )}.`;
  }

  getTagsSummary() {
    const diffs = this.props.delta.diffs;
    if (
      diffs[CONSTS.DELTA_TAG_ADD].length &&
      diffs[CONSTS.DELTA_TAG_REMOVE].length
    ) {
      return `Add ${
        diffs[CONSTS.DELTA_TAG_ADD].length
      } new ${pluraliseIfMoreThanOne(
        'tag',
        diffs[CONSTS.DELTA_TAG_ADD].length
      )} and remove ${diffs[CONSTS.DELTA_TAG_REMOVE].length}.`;
    }
    if (diffs[CONSTS.DELTA_SAMPLE_ADD].length) {
      return `Add ${
        diffs[CONSTS.DELTA_TAG_ADD].length
      } new ${pluraliseIfMoreThanOne(
        'tag',
        diffs[CONSTS.DELTA_TAG_ADD].length
      )}.`;
    }
    return `Remove ${
      diffs[CONSTS.DELTA_TAG_REMOVE].length
    } ${pluraliseIfMoreThanOne('tag', diffs[CONSTS.DELTA_TAG_REMOVE].length)}.`;
  }

  getSkillSummary() {
    const diffs = this.props.delta.diffs;
    if (diffs[CONSTS.DELTA_SKILL_ADD] && diffs[CONSTS.DELTA_SKILL_REMOVE]) {
      return `Replace the used skill`;
    }
    if (diffs[CONSTS.DELTA_SKILL_ADD]) {
      return `Use a skill`;
    }
    if (diffs[CONSTS.DELTA_SKILL_REMOVE]) {
      return `Stop using a skill`;
    }
  }

  renderGroups() {
    const diffs = this.props.delta.diffs;
    const groups = [
      {
        name: 'Questions',
        summary: this.getQuestionsSummary(),
        diffs: Object.assign(
          {},
          defaultBlankDelta,
          { [CONSTS.DELTA_SAMPLE_ADD]: diffs[CONSTS.DELTA_SAMPLE_ADD] },
          { [CONSTS.DELTA_SAMPLE_REMOVE]: diffs[CONSTS.DELTA_SAMPLE_REMOVE] }
        ),
      },
      {
        name: 'Answers',
        summary: this.getAnswersSummary(),
        diffs: Object.assign(
          {},
          defaultBlankDelta,
          { [CONSTS.DELTA_ANSWER_ADD]: diffs[CONSTS.DELTA_ANSWER_ADD] },
          { [CONSTS.DELTA_ANSWER_REMOVE]: diffs[CONSTS.DELTA_ANSWER_REMOVE] }
        ),
      },
      {
        name: 'Skill',
        summary: this.getSkillSummary(),
        diffs: Object.assign(
          {},
          defaultBlankDelta,
          { [CONSTS.DELTA_SKILL_ADD]: diffs[CONSTS.DELTA_SKILL_ADD] },
          { [CONSTS.DELTA_SKILL_REMOVE]: diffs[CONSTS.DELTA_SKILL_REMOVE] }
        ),
      },
      {
        name: 'Tags',
        summary: this.getTagsSummary(),
        diffs: Object.assign(
          {},
          defaultBlankDelta,
          { [CONSTS.DELTA_TAG_ADD]: diffs[CONSTS.DELTA_TAG_ADD] },
          { [CONSTS.DELTA_TAG_REMOVE]: diffs[CONSTS.DELTA_TAG_REMOVE] }
        ),
      },
    ];

    return groups.map((group, key) => {
      const hasItems = Object.keys(group.diffs).some((diffKey) => {
        if (
          [CONSTS.DELTA_SKILL_ADD, CONSTS.DELTA_SKILL_REMOVE].includes(diffKey)
        ) {
          return Boolean(group.diffs[diffKey]);
        }
        return group.diffs[diffKey].length > 0;
      });
      if (!hasItems) return null;

      return (
        <div key={key} className="DeltaModal-groupContainer">
          <div className="DeltaModal-GroupSection">
            <div className="DeltaModal-GroupSectionName">{group.name}</div>
            <div className="DeltaModal-GroupSectionSummary">
              {group.summary}
            </div>
          </div>
          <div className="DeltaModal-GroupSection">
            <div className="DeltaModal-GroupSectionName">Changes</div>
            <div className="DeltaModal-DeltaChangesContainer">
              <DeltaChangesWrapper diffs={group.diffs} />
            </div>
          </div>
        </div>
      );
    });
  }

  render() {
    return (
      <GeckoModal name="Import Answers" btns={this.btns}>
        <div className="DeltaModal">
          <div className="DeltaModal-title">Review Import</div>
          <div className="DeltaModal-description">
            Accepting this modification will apply all of the below changes to
            the answer.
          </div>
          <div className="DeltaModal-groups">{this.renderGroups()}</div>
        </div>
      </GeckoModal>
    );
  }
}

const mapStateToProps = (state, props) => {
  return {
    delta: state.botsRoute.deltasById[props.deltaId],
  };
};

export default connect(mapStateToProps)(DeltaModal);
